// extracted by mini-css-extract-plugin
module.exports = {"downloadBtn":"TxtPreview_downloadBtn_3gPna"};